import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router';
import { isUploading, useAllDrafts } from './drafts';

/**
 * While Comms uploads carry on elsewhere in the app, a pill in the corner says
 * so and takes you back to the message. Closing the window mid-upload asks first.
 */
export function UploadsPill() {
  const drafts = useAllDrafts();
  const { pathname } = useLocation();
  const busy = Object.values(drafts).filter(isUploading);

  useEffect(() => {
    if (!busy.length) return;
    const warn = (e: BeforeUnloadEvent) => e.preventDefault();
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [busy.length]);

  // Comms shows its own progress, in the box and the channel list.
  if (!busy.length || pathname.startsWith('/comms')) return null;
  return (
    <div role="status" className="fixed right-4 bottom-4 z-40 flex flex-col gap-1.5">
      {busy.map((d) => {
        const files = d.uploads.filter((u) => !u.done && !u.error);
        const progress = files.reduce((n, u) => n + u.progress, 0) / files.length;
        return (
          <Link
            key={d.href}
            to={d.href}
            className="flex items-center gap-2 bg-bg-2 px-3 py-2 font-mono text-[11px] text-text shadow-[0_0_0_1px_var(--color-yellow),0_8px_24px_rgb(0_0_0/0.5)] hover:text-yellow"
          >
            <Loader2 className="size-3.5 animate-spin text-yellow" aria-hidden />
            <span>
              Uploading {files.length === 1 ? files[0]!.name : `${files.length} files`} for {d.where} ·{' '}
              {Math.round(progress * 100)}%
            </span>
          </Link>
        );
      })}
    </div>
  );
}
